import { useQuery } from '../useQuery';
import { getTask } from '@dispatch/shared/services';

export const useGetTask = (taskId: string, resourceId?: string) => {
  const { data, status, refetch } = useQuery(['task', taskId, resourceId], () =>
    getTask(taskId, resourceId)
  );

  return {
    task: data,
    taskStatus: status,
    fetchTask: refetch,
  };
};
